export enum BUTTON_TYPES {
  SUBMIT = 'submit',
  BUTTON = 'button',
  RESET = 'reset',
}
